import { render, staticRenderFns } from "./LoadAndShow.vue?vue&type=template&id=2b79b170&"
import script from "./LoadAndShow.vue?vue&type=script&lang=js&"
export * from "./LoadAndShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports